import _regeneratorRuntime from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import api from '@/api';
import { AccountLogin } from '@api/sys.login';
import request from '@/plugin/axios';
import helper from '@/libs/helper.js';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    // async login ({ dispatch }, {
    //   username = '',
    //   password = ''
    // } = {}) {
    //   const res = await api.SYS_USER_LOGIN({ username, password })
    //   // 设置 cookie 一定要存 uuid 和 token 两个 cookie
    //   // 整个系统依赖这两个数据进行校验和存储
    //   // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
    //   // token 代表用户当前登录状态 建议在网络请求中携带 token
    //   // 如有必要 token 需要定时更新，默认保存一天
    //   util.cookies.set('uuid', res.uuid)
    //   util.cookies.set('token', res.token)
    //   // 设置 vuex 用户信息
    //   await dispatch('d2admin/user/set', { name: res.name }, { root: true })
    //   // 用户登录后从持久化数据加载一系列的设置
    //   await dispatch('load')
    // },
    login: function login(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dispatch, _ref2, _ref2$username, username, _ref2$password, password, url, data, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch;
              _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$username = _ref2.username, username = _ref2$username === void 0 ? '' : _ref2$username, _ref2$password = _ref2.password, password = _ref2$password === void 0 ? '' : _ref2$password;
              // const res = await api.SYS_USER_LOGIN({ username, password })
              url = helper.apiUrl.doLogin;
              data = {
                username: username,
                password: password
              };
              _context.next = 6;
              return request.post(url, data);
            case 6:
              res = _context.sent;
              // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天

              console.log('11111111', res);
              // util.cookies.set('uuid', res.uuid);1
              // util.cookies.set('token', res.token);
              if (!(res.code == 0)) {
                _context.next = 22;
                break;
              }
              util.cookies.set('uuid', res.data.id);
              // console.log("account.js token", res.data.token);
              util.cookies.set('token', res.data.token);
              localStorage['admin_id'] = res.data.id;
              localStorage['username'] = res.data.username;
              localStorage['appkey'] = res.data.appkey;
              localStorage['apcode'] = res.data.apcode;
              localStorage['is_root'] = res.data.is_root;
              localStorage['team_id'] = res.data.team_id;
              localStorage['new_token'] = res.data.new_token; //接收后台返回的新token
              // 设置 vuex 用户信息
              _context.next = 20;
              return dispatch('d2admin/user/set', {
                name: res.data.admin_name
              }, {
                root: true
              });
            case 20:
              _context.next = 22;
              return dispatch('load');
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // async login ({ dispatch }, {
    //   username = '',
    //   password = ''
    // } = {}) {
    //   return new Promise((resolve, reject) => {
    //     // 开始请求登录接口
    //     /*api.AccountLogin({
    //       username,
    //       password
    //     })*/
    //     AccountLogin({
    //       username,
    //       password
    //     })
    //         .then(async res => {
    //           // 设置 cookie 一定要存 uuid 和 token 两个 cookie
    //           // 整个系统依赖这两个数据进行校验和存储
    //           // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
    //           // token 代表用户当前登录状态 建议在网络请求中携带 token
    //           // 如有必要 token 需要定时更新，默认保存一天
    //           if(res.code==0){
    //             console.log("logincheck res",res);
    //             util.cookies.set('uuid', res.data.id)
    //             util.cookies.set('token', res.data.token);
    //             console.log("res.data.id",res.data.id);
    //             localStorage['admin_id']=res.data.id;
    //             localStorage['username']=res.data.username;
    //             localStorage['pwd']=res.data.pwd;
    //
    //             // 设置 vuex 用户信息
    //             await dispatch('d2admin/user/set', {
    //               name: res.data.username,
    //             }, { root: true })
    //             // 用户登录后从持久化数据加载一系列的设置
    //             await dispatch('load')
    //             // 结束
    //             resolve()
    //           }else{
    //
    //             Message({
    //               message: res.msg,
    //               type: 'error',
    //               duration: 5 * 1000
    //             })
    //           }
    //
    //         })
    //         .catch(err => {
    //           console.log('err: ', err)
    //           reject(err)
    //
    //         })
    //   })
    // },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref3) {
      var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$confirm = _ref4.confirm,
        confirm = _ref4$confirm === void 0 ? false : _ref4$confirm;
      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认
      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                // 删除cookie
                util.cookies.remove('token');
                util.cookies.remove('uuid');
                localStorage.removeItem("username");
                localStorage.removeItem("admin_id");
                localStorage.removeItem("appkey");
                localStorage.removeItem("apcode");
                sessionStorage.removeItem("msg_id");
                // 清空 vuex 用户信息
                _context2.next = 9;
                return dispatch('d2admin/user/set', {}, {
                  root: true
                });
              case 9:
                _context2.next = 11;
                return dispatch('d2admin/user/setMsgCount', 0, {
                  root: true
                });
              case 11:
                // 跳转路由
                router.push({
                  name: 'login'
                });
              case 12:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return _logout.apply(this, arguments);
      }
      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消注销操作'
          });
        });
      } else {
        logout();
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref5) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var dispatch;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              dispatch = _ref5.dispatch;
              _context3.next = 3;
              return dispatch('d2admin/user/load', null, {
                root: true
              });
            case 3:
              _context3.next = 5;
              return dispatch('d2admin/theme/load', null, {
                root: true
              });
            case 5:
              _context3.next = 7;
              return dispatch('d2admin/transition/load', null, {
                root: true
              });
            case 7:
              _context3.next = 9;
              return dispatch('d2admin/page/openedLoad', null, {
                root: true
              });
            case 9:
              _context3.next = 11;
              return dispatch('d2admin/menu/asideLoad', null, {
                root: true
              });
            case 11:
              _context3.next = 13;
              return dispatch('d2admin/size/load', null, {
                root: true
              });
            case 13:
              _context3.next = 15;
              return dispatch('d2admin/color/load', null, {
                root: true
              });
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};